<div class="p-4 relative">
  <div class="min-h-[400px]" cdkDropList (cdkDropListDropped)="onDrop($event)" [cdkDropListData]="filteredFlowMarketplaces">
    <div class="inline-block">
      <div class="overflow-x-auto">
      <div class="w-fit">
      <!-- All Marketplaces Heading -->
      <div class="flex items-center gap-2 mb-4">
        <h2 class="text-2xl font-semibold text-momentum-deep_purple">All Marketplaces</h2>
        <app-info-modal-button [data]="allMarketplacesInfo"></app-info-modal-button>
      </div>

      <!-- New Marketplace and New Source Buttons -->
      <div class="flex items-center justify-end mb-4">
        <div class="flex gap-2">
          <button class="bg-momentum-deep_purple text-white px-4 py-2 rounded-full flex items-center gap-2" [routerLink]="['/admin', 'marketplaces', 'new']">
            <fa-icon [icon]="faPlus"></fa-icon>
            Add New Marketplace
          </button>
          <button class="bg-gray-300 text-white px-4 py-2 rounded-full flex items-center gap-2 cursor-not-allowed" disabled>
            <fa-icon [icon]="faPlus"></fa-icon>
            Add New Source
          </button>
        </div>
      </div>

      <!-- Show Disabled Marketplaces Toggle -->
      <div class="flex justify-start items-center mb-4 gap-2">
        <span class="text-sm font-semibold text-agentium_gray-text">Show Disabled Marketplaces</span>
        <div
          role="switch"
          class="relative inline-block w-10 h-6 rounded-full cursor-pointer"
          [attr.aria-checked]="showDisabledMarketplaces"
          tabindex="0"
          (click)="showDisabledMarketplaces = !showDisabledMarketplaces"
          (keydown.space)="showDisabledMarketplaces = !showDisabledMarketplaces; $event.preventDefault()"
        >
          <div class="w-full h-full rounded-full transition-colors duration-200 ease-in-out" [ngClass]="showDisabledMarketplaces ? 'bg-momentum-deep_purple' : 'bg-gray-300'"></div>
          <div
            class="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transform transition-transform duration-200 ease-in-out"
            [ngClass]="showDisabledMarketplaces ? 'translate-x-4' : 'translate-x-0'"
          ></div>
        </div>
      </div>

      <div>
        <div class="rounded-lg overflow-hidden border border-gray-200 [&_tr:last-child>td]:border-b-0">
        <!-- Flow Marketplaces Table -->
        <table class="table-auto border-collapse bg-white">
          <!-- Table Headers -->
          <thead>
            <tr>
              <th class="border-b p-3 text-agentium_gray-text text-left whitespace-nowrap">Marketplace</th>
              <th class="border-b p-3 text-agentium_gray-text text-center whitespace-nowrap w-20">Actions</th>
              <th class="border-b p-3 text-agentium_gray-text text-center whitespace-nowrap w-20">Enabled</th>
              <th class="border-b p-3 text-agentium_gray-text text-center whitespace-nowrap w-28">Delivered Price</th>
              <th class="border-b p-3 text-agentium_gray-text text-center whitespace-nowrap w-28">Prepaid Balance</th>
              <th class="border-b p-3 text-agentium_gray-text text-center whitespace-nowrap w-28">
                Last Delivered
                <button
                  class="ml-1 text-momentum-deep_purple hover:text-momentum-royal_purple"
                  title="Refresh delivery stats"
                  (click)="refreshDeliveryStats($event)"
                  [disabled]="isLoadingDeliveryStats"
                >
                  <fa-icon [icon]="faSync" [class.animate-spin]="isLoadingDeliveryStats" size="sm"></fa-icon>
                </button>
              </th>
              <th class="border-b p-3 text-agentium_gray-text text-center whitespace-nowrap w-24">
                Daily Limit
                <button
                  [customCdkTooltip]="dailyLimitToolTipContent"
                  customCdkTooltipPosition="below"
                  customCdkTooltipClass="daily-limit-tooltip-panel"
                  type="button"
                >
                  <fa-icon [icon]="faInfoCircle" class="text-momentum-deep_purple" size="sm"></fa-icon>
                  <span class="sr-only">Show daily limit tool tip</span>
                </button>
                <ng-template #dailyLimitToolTipContent>
                  <div
                    class="p-3 space-y-2 absolute z-50 inline-block text-sm text-left text-momentum-black transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow w-64 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400"
                  >
                    <p><span class="inline-block w-2 h-2 rounded-full bg-green-500 mr-1"></span> Available — under the limit, or no limit configured.</p>
                    <p><span class="inline-block w-2 h-2 rounded-full bg-yellow-500 mr-1"></span> Low usage — under 15% of the limit delivered so far.</p>
                    <p><span class="inline-block w-2 h-2 rounded-full bg-red-500 mr-1"></span> Limit reached — no more referrals will be sent until the next reset.</p>
                  </div>
                </ng-template>
              </th>
              <th class="border-b p-3 text-agentium_gray-text text-center whitespace-nowrap w-28">
                Monthly Limit
                <button
                  [customCdkTooltip]="monthlyLimitToolTipContent"
                  customCdkTooltipPosition="below"
                  customCdkTooltipClass="monthly-limit-tooltip-panel"
                  type="button"
                >
                  <fa-icon [icon]="faInfoCircle" class="text-momentum-deep_purple" size="sm"></fa-icon>
                  <span class="sr-only">Show monthly limit tool tip</span>
                </button>
                <ng-template #monthlyLimitToolTipContent>
                  <div
                    class="p-3 space-y-2 absolute z-50 inline-block text-sm text-left text-momentum-black transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow w-64 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400"
                  >
                    <p>Monthly limits reset at the start of each calendar month. Referrals resume as soon as the next month starts.</p>
                    <p><span class="inline-block w-2 h-2 rounded-full bg-green-500 mr-1"></span> Available — under the limit, or no limit configured.</p>
                    <p><span class="inline-block w-2 h-2 rounded-full bg-yellow-500 mr-1"></span> Low usage — under 15% of the limit delivered so far.</p>
                    <p><span class="inline-block w-2 h-2 rounded-full bg-red-500 mr-1"></span> Limit reached — the "Next" date shows when the new month starts.</p>
                  </div>
                </ng-template>
              </th>
              <th class="border-b p-3 text-agentium_gray-text text-center whitespace-nowrap w-24">Categories</th>
            </tr>
          </thead>

          <!-- Table Body -->
          <tbody>
            @for (marketplace of filteredFlowMarketplaces; track marketplace.id) {
              <!-- NOTE: for `[cdkDragDisabled]="!marketplace.enabled"` below Typescript is should error
              `TS2322: Type boolean is not assignable to type typeof CdkDrag<T>`
              however this is the correct implementation and it works as desired -->
              <tr
                cdkDrag
                [cdkDragData]="marketplace"
                (cdkDragStarted)="onDragStarted()"
                (cdkDragEnded)="onDragEnded()"
                [cdkDragDisabled]="!marketplace.enabled"
                class="hover:bg-gray-50 transition-colors"
              >
                <!-- Marketplace Column -->
                <td class="border-b p-3">
                  <div class="flex items-center">
                    @if (marketplace.enabled) {
                      <fa-icon [icon]="faGripLines" class="mr-2 text-agentium_gray-text cursor-move flex-shrink-0" cdkDragHandle></fa-icon>
                    }
                    <div class="flex-1 min-w-0">
                      <div>
                        <a
                          [ngClass]="{
                            'text-momentum-royal_purple': marketplace.marketplaceName === 'MARKETPLACE',
                            'text-momentum-deep_purple': marketplace.marketplaceName !== 'MARKETPLACE'
                          }"
                          class="font-medium hover:text-momentum-royal_purple whitespace-nowrap"
                          >{{ marketplace.marketplaceName }}</a
                        >
                      </div>
                      <!-- Display agency info if available -->
                      @if (getAgencyForMarketplace(marketplace); as agency) {
                        <div class="mt-1">
                          <p class="text-agentium_gray-text text-sm whitespace-nowrap">{{ agency.address?.city }}, {{ agency.address?.regionCode }} {{ agency.address?.zipCode }}</p>
                          <p class="text-agentium_gray-text text-sm whitespace-nowrap">Agency ID# {{ agency.fulcrumId }}</p>
                        </div>
                      }
                    </div>
                  </div>
                </td>

                <!-- Actions Column -->
                <td class="border-b p-3 text-center w-20">
                  <button class="text-gray-500 hover:text-black text-xl" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="openActionsMenu(marketplace.id, trigger)">
                    <fa-icon [icon]="faEllipsisV" size="lg"></fa-icon>
                  </button>

                  @if (currentOverlayOrigin && isActionsMenuOpen(marketplace.id)) {
                    <ng-template
                      cdk-connected-overlay
                      [cdkConnectedOverlayOrigin]="currentOverlayOrigin"
                      [cdkConnectedOverlayOpen]="isActionsMenuOpen(marketplace.id)"
                      [cdkConnectedOverlayHasBackdrop]="true"
                      (backdropClick)="closeActionsMenu()"
                    >
                      <div class="mt-2 w-56 origin-top-right bg-white border border-gray-200 rounded shadow-md z-50">
                        <button
                          class="block w-full text-left px-4 py-2 hover:bg-gray-100 text-momentum-deep_purple hover:text-momentum-royal_purple"
                          [routerLink]="['/admin', 'marketplaces', marketplace.id]"
                          (click)="closeActionsMenu()"
                        >
                          Edit Marketplace Appetite
                        </button>
                        <button
                          class="block w-full text-left px-4 py-2 hover:bg-gray-100 text-momentum-deep_purple hover:text-momentum-royal_purple"
                          (click)="openChangelogModal(marketplace)"
                        >
                          View Changelog
                        </button>
                        <button class="block w-full text-left px-4 py-2 text-gray-400 cursor-not-allowed" disabled>View Referral Activity</button>
                      </div>
                    </ng-template>
                  }
                </td>

                <!-- Enabled Column -->
                <td class="border-b p-3 text-center w-20">
                  <div class="flex justify-center items-center">
                    <div
                      role="switch"
                      class="relative inline-block w-10 h-6 rounded-full cursor-pointer"
                      [attr.aria-checked]="marketplace.enabled"
                      tabindex="0"
                      (click)="toggleMarketplaceEnabled(marketplace)"
                      (keydown.space)="toggleMarketplaceEnabled(marketplace); $event.preventDefault()"
                    >
                      <div class="w-full h-full rounded-full transition-colors duration-200 ease-in-out" [ngClass]="marketplace.enabled ? 'bg-momentum-deep_purple' : 'bg-gray-300'"></div>
                      <div
                        class="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transform transition-transform duration-200 ease-in-out"
                        [ngClass]="marketplace.enabled ? 'translate-x-4' : 'translate-x-0'"
                      ></div>
                    </div>
                  </div>
                </td>

                <!-- Delivered Price Column -->
                <td class="border-b p-3 text-center w-28">
                  <span class="whitespace-nowrap text-agentium_gray-text">{{ getFormattedDeliveredPrice(marketplace) }}</span>
                </td>

                <!-- Prepaid Balance Column -->
                <td class="border-b p-3 text-center w-28">
                  <span class="whitespace-nowrap text-agentium_gray-text" [ngClass]="getPrepaidBalanceClass(marketplace)">{{ getFormattedPrepaidBalance(marketplace) }}</span>
                </td>

                <!-- Last Delivered Column -->
                <td class="border-b p-3 text-center w-28">
                  <span class="whitespace-nowrap text-agentium_gray-text" [innerHTML]="getFormattedLastDelivered(marketplace)"></span>
                </td>

                <!-- Daily Limit Column -->
                <td class="border-b p-3 text-center w-24">
                  <span class="whitespace-nowrap text-agentium_gray-text" [innerHTML]="getFormattedDailyLimit(marketplace)"></span>
                </td>

                <!-- Monthly Limit Column -->
                <td class="border-b p-3 text-center w-28">
                  <span class="whitespace-nowrap text-agentium_gray-text" [innerHTML]="getFormattedMonthlyLimit(marketplace)"></span>
                </td>

                <!-- Categories Column -->
                @if (marketplace.riskAppetite) {
                  <td
                    class="border-b p-3 text-center w-24"
                    [ngClass]="{
                      'text-momentum-royal_purple': marketplace.marketplaceName === 'MARKETPLACE',
                      'text-agentium_gray-text': marketplace.marketplaceName !== 'MARKETPLACE'
                    }"
                  >
                    <span class="whitespace-nowrap">{{ getCategory(marketplace.riskAppetite) }}</span>
                  </td>
                }

                <ng-template cdkDragPreview>
                  <div class="bg-white p-2 rounded shadow-lg border border-gray-200">
                    {{ marketplace.marketplaceName }}
                  </div>
                </ng-template>
              </tr>
            }
          </tbody>
        </table>
        </div>
      </div>

      <!-- Save and Discard Buttons -->
      @if (!isLoading) {
        <div class="flex justify-end gap-4 mt-12">
          <button
            class="px-6 py-2 bg-momentum-deep_purple enabled:text-white rounded-full disabled:bg-agentium_gray-text disabled:cursor-not-allowed"
            (click)="updateMarketplaces()"
            [disabled]="!hasUnsavedChanges || isSaving"
          >
            Save Updates
          </button>
          <button
            class="px-6 py-2 bg-agentium_white-backdrop border border-gray-300 rounded-full disabled:bg-agentium_gray-text disabled:cursor-not-allowed"
            (click)="discardChanges()"
            [disabled]="!hasUnsavedChanges"
          >
            Discard Changes
          </button>
        </div>
      }
      </div>
      </div>

      <!-- Marketplace Error Activity Section -->
      @if (!isLoading) {
        <div class="mt-12">
          <div class="flex items-center gap-2 mb-1">
            <h2 class="text-2xl font-semibold text-momentum-deep_purple">Marketplace Error Activity</h2>
            <app-info-modal-button [data]="errorActivityInfo"></app-info-modal-button>
          </div>
          <p class="text-sm text-agentium_gray-text mb-4">Review delivery errors and non-delivery outcomes across marketplaces.</p>

          <!-- Show Only Delivery Errors Checkbox -->
          <div class="flex justify-end mb-3">
            <label class="flex items-center gap-2 text-sm text-agentium_gray-text cursor-pointer font-bold">
              <input
                type="checkbox"
                [checked]="showOnlyDeliveryErrors"
                (change)="onDeliveryErrorFilterToggle($any($event.target).checked)"
                class="w-4 h-4 cursor-pointer text-momentum-deep_purple border-gray-300 rounded focus:ring-momentum-deep_purple"
              />
              Show only delivery errors
            </label>
          </div>

          <div class="relative">
            <div class="overflow-x-auto">
              <div class="rounded-lg overflow-hidden border border-gray-200 [&_tr:last-child>td]:border-b-0">
              <!-- Marketplace Error Activity Table -->
              <table class="table-auto border-collapse w-full bg-white">
                <!-- Table Headers -->
                <thead>
                  <tr>
                    <th class="border-b px-4 py-3 text-agentium_gray-text text-left whitespace-nowrap">Date</th>
                    <th class="border-b px-4 py-3 text-agentium_gray-text text-center whitespace-nowrap">Opportunity Id</th>
                    <th class="border-b px-4 py-3 text-agentium_gray-text text-left whitespace-nowrap">Error Status</th>
                    <th class="border-b px-4 py-3 text-agentium_gray-text text-left whitespace-nowrap">Error Marketplace Name</th>
                    <th class="border-b px-4 py-3 text-agentium_gray-text text-left whitespace-nowrap">Error Notes</th>
                    <th class="border-b px-4 py-3 text-agentium_gray-text text-left whitespace-nowrap">Current Marketplace</th>
                    <th class="border-b px-4 py-3 text-agentium_gray-text text-left whitespace-nowrap">Current Status</th>
                  </tr>
                </thead>

                <!-- Table Body -->
                <tbody>
                  @if (!isLoadingDeliveryErrors && deliveryErrors.length === 0) {
                    <tr>
                      <td colspan="7" class="border-b px-4 py-3 text-center text-agentium_gray-text">No error activity found</td>
                    </tr>
                  } @else {
                    @for (deliveryError of deliveryErrors; track deliveryError.opportunityId) {
                      <tr class="hover:bg-gray-50 transition-colors">
                        <td class="border-b px-4 py-3 text-agentium_gray-text whitespace-nowrap">{{ formatDate(deliveryError.errorDate) }}</td>
                        <td class="border-b px-4 py-3 text-momentum-deep_purple font-medium whitespace-nowrap text-center">{{ deliveryError.opportunityId }}</td>
                        <td class="border-b px-4 py-3 whitespace-nowrap">
                          <span [ngClass]="deliveryError.errorStatus === 'DELIVERY_ERROR' ? 'text-red-600 font-medium' : 'text-agentium_gray-text'">
                            {{ deliveryError.errorStatus === 'DELIVERY_ERROR' ? 'DELIVERY ERROR' : 'REJECTED BY PARTNER' }}
                          </span>
                        </td>
                        <td class="border-b px-4 py-3 text-agentium_gray-text break-words">{{ deliveryError.errorMarketplaceName }}</td>
                        <td class="border-b px-4 py-3 text-agentium_gray-text max-w-xs">
                          <span [ngClass]="isNotesExpanded(deliveryError.opportunityId) ? '' : 'line-clamp-2'">{{ deliveryError.errorNotes }}</span>
                          @if (deliveryError.errorNotes && deliveryError.errorNotes.length > 120) {
                            <button class="text-momentum-deep_purple text-xs mt-1 block" (click)="toggleNotes(deliveryError.opportunityId)">
                              {{ isNotesExpanded(deliveryError.opportunityId) ? 'See less' : '... See more' }}
                            </button>
                          }
                        </td>
                        <td class="border-b px-4 py-3 text-agentium_gray-text break-words">{{ deliveryError.currentMarketplaceName }}</td>
                        <td class="border-b px-4 py-3 text-agentium_gray-text break-words">{{ deliveryError.currentMarketplaceStatus }}</td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
              </div>
            </div>

            <!-- Pagination Controls -->
            <div class="flex justify-between items-center mt-4">
              <div class="flex items-center gap-4">
                <div class="text-sm text-agentium_gray-text">
                  @if (totalDeliveryErrors > 0) {
                    Showing {{ (currentDeliveryErrorsPage - 1) * deliveryErrorsPageSize + 1 }} to
                    {{ Math.min(currentDeliveryErrorsPage * deliveryErrorsPageSize, totalDeliveryErrors) }}
                    of {{ totalDeliveryErrors }} errors
                  } @else {
                    No results found
                  }
                </div>
                <div class="flex items-center gap-2">
                  <span class="text-sm text-agentium_gray-text">Rows per page:</span>
                  <select
                    (change)="onPageSizeChange(+$any($event.target).value)"
                    [value]="deliveryErrorsPageSize"
                    class="border border-gray-300 rounded text-sm text-agentium_gray-text px-2 py-1"
                  >
                    @for (opt of pageSizeOptions; track opt) {
                      <option [value]="opt">{{ opt }}</option>
                    }
                  </select>
                </div>
              </div>

              <div class="flex items-center gap-2">
                <button
                  class="px-3 py-1 bg-momentum-deep_purple text-white rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  (click)="previousDeliveryErrorsPage()"
                  [disabled]="currentDeliveryErrorsPage <= 1 || isLoadingDeliveryErrors"
                >
                  <fa-icon [icon]="faChevronLeft" size="sm"></fa-icon>
                  Previous
                </button>

                <span class="text-sm text-agentium_gray-text"> Page {{ currentDeliveryErrorsPage }} of {{ totalDeliveryErrorsPages }} </span>

                <button
                  class="px-3 py-1 bg-momentum-deep_purple text-white rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  (click)="nextDeliveryErrorsPage()"
                  [disabled]="currentDeliveryErrorsPage >= totalDeliveryErrorsPages || isLoadingDeliveryErrors"
                >
                  Next
                  <fa-icon [icon]="faChevronRight" size="sm"></fa-icon>
                </button>
              </div>
            </div>

            <!-- Marketplace Error Activity Loading Spinner -->
            @if (isLoadingDeliveryErrors) {
              <div class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70">
                <fa-icon [icon]="faGear" animation="spin" class="p-4 text-slate-600" size="2xl"></fa-icon>
              </div>
            }
          </div>
        </div>
      }

      <!-- Non Flow Marketplaces Section -->
      @if (!isLoading && nonFlowMarketplaces.length > 0) {
        <div class="mt-12">
          <div class="flex items-center gap-2 mb-4">
            <h2 class="text-2xl font-semibold text-momentum-deep_purple">Non Flow Marketplaces</h2>
            <app-info-modal-button [data]="nonFlowInfo"></app-info-modal-button>
          </div>

          <div class="overflow-x-auto">
            <div class="rounded-lg overflow-hidden border border-gray-200 [&_tr:last-child>td]:border-b-0 w-fit">
            <!-- Non Flow Marketplaces Table -->
            <table class="table-auto border-collapse bg-white">
              <!-- Table Headers -->
              <thead>
                <tr>
                  <th class="border-b p-3 text-agentium_gray-text text-left whitespace-nowrap">Marketplace</th>
                  <th class="border-b p-3 pl-8 text-agentium_gray-text text-center whitespace-nowrap w-28">
                    Last Delivered
                    <button
                      class="ml-1 text-momentum-deep_purple hover:text-momentum-royal_purple"
                      title="Refresh delivery stats"
                      (click)="refreshDeliveryStats($event)"
                      [disabled]="isLoadingDeliveryStats"
                    >
                      <fa-icon [icon]="faSync" [class.animate-spin]="isLoadingDeliveryStats" size="sm"></fa-icon>
                    </button>
                  </th>
                  <th class="border-b p-3 text-agentium_gray-text text-center whitespace-nowrap w-24">Daily Count</th>
                  <th class="border-b p-3 text-agentium_gray-text text-center whitespace-nowrap w-24">Creation Date</th>
                </tr>
              </thead>

              <!-- Table Body -->
              <tbody>
                @for (marketplace of nonFlowMarketplaces; track marketplace.id) {
                  <tr class="hover:bg-gray-50 transition-colors">
                    <!-- Marketplace Column -->
                    <td class="border-b p-3">
                      <div class="flex items-center">
                        <div class="flex-1 min-w-0">
                          <div>
                            <a
                              [ngClass]="{
                                'text-momentum-royal_purple': marketplace.marketplaceName === 'MARKETPLACE',
                                'text-momentum-deep_purple': marketplace.marketplaceName !== 'MARKETPLACE'
                              }"
                              class="font-medium hover:text-momentum-royal_purple whitespace-nowrap"
                              >{{ marketplace.marketplaceName }}</a
                            >
                          </div>
                          <!-- Display agency info if available -->
                          @if (getAgencyForMarketplace(marketplace); as agency) {
                            <div class="mt-1">
                              <p class="text-agentium_gray-text text-sm whitespace-nowrap">{{ agency.address?.city }}, {{ agency.address?.regionCode }} {{ agency.address?.zipCode }}</p>
                              <p class="text-agentium_gray-text text-sm whitespace-nowrap">Agency ID# {{ agency.fulcrumId }}</p>
                            </div>
                          }
                        </div>
                      </div>
                    </td>

                    <!-- Last Delivered Column -->
                    <td class="border-b p-3 pl-8 text-center w-28">
                      <span class="whitespace-nowrap text-agentium_gray-text" [innerHTML]="getFormattedLastDelivered(marketplace)"></span>
                    </td>

                    <!-- Daily Count Column -->
                    <td class="border-b p-3 text-center w-24">
                      <span class="whitespace-nowrap text-agentium_gray-text" [innerHTML]="getFormattedDailyCount(marketplace)"></span>
                    </td>

                    <!-- Creation Date Column -->
                    <td class="border-b p-3 text-center w-24">
                      <span class="whitespace-nowrap text-agentium_gray-text"> {{ formatDate(marketplace.creationDate!) }}</span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Data Loading Spinner -->
  @if (isLoading || isSaving) {
    <div class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70">
      <fa-icon [icon]="faGear" animation="spin" class="p-4 text-slate-600" size="2xl"></fa-icon>
    </div>
  }
</div>
